/*
  GiftGo banner carousel.

  A compact, auto-rotating, swipeable hero carousel. Each slide is a section
  block rendered in Liquid; this element only handles motion: auto-advance,
  touch swipe, and the dot indicators. Vanilla JS, no dependencies. With no JS
  the slides stack as a scroll-snap row, so the banner is still usable.
*/
(function () {
  'use strict';

  class GiftGoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-carousel-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-carousel-dot]'));
      if (!this.track || this.slides.length === 0) return;

      this.index = 0;
      this.interval = (parseInt(this.dataset.interval, 10) || 5) * 1000;
      this.timer = null;

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.dots.forEach(
        function (dot, i) {
          dot.addEventListener('click', function () {
            this.goTo(i, true);
          }.bind(this));
        }.bind(this)
      );

      // Pause auto-rotate while the buyer is interacting.
      ['pointerdown', 'touchstart', 'mouseenter'].forEach(
        function (evt) {
          this.addEventListener(evt, this.pause.bind(this), { passive: true });
        }.bind(this)
      );
      ['pointerup', 'touchend', 'mouseleave'].forEach(
        function (evt) {
          this.addEventListener(evt, this.play.bind(this), { passive: true });
        }.bind(this)
      );

      document.addEventListener(
        'visibilitychange',
        function () {
          if (document.hidden) {
            this.pause();
          } else {
            this.play();
          }
        }.bind(this)
      );

      if (this.slides.length > 1) this.play();
    }

    disconnectedCallback() {
      this.pause();
    }

    slideWidth() {
      return this.slides[0] ? this.slides[0].offsetWidth : this.track.offsetWidth;
    }

    onScroll() {
      // Derive the active slide from scroll position so the dots follow swipes.
      window.clearTimeout(this._scrollEnd);
      this._scrollEnd = window.setTimeout(
        function () {
          var i = Math.round(this.track.scrollLeft / this.slideWidth());
          this.setActive(i);
        }.bind(this),
        80
      );
    }

    setActive(i) {
      if (i < 0 || i >= this.slides.length || i === this.index) return;
      this.index = i;
      this.dots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === i);
        dot.setAttribute('aria-selected', di === i ? 'true' : 'false');
      });
    }

    goTo(i, fromTap) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: this.slideWidth() * this.index, behavior: 'smooth' });
      this.setActive(this.index);
      if (fromTap) {
        this.pause();
        this.play();
      }
    }

    next() {
      this.goTo(this.index + 1);
    }

    play() {
      if (this.timer || this.slides.length < 2) return;
      this.timer = window.setInterval(this.next.bind(this), this.interval);
    }

    pause() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('giftgo-carousel')) {
    customElements.define('giftgo-carousel', GiftGoCarousel);
  }
})();
